"use client";

import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import styles from "./AbtFeatures.module.css";

export interface FeatureItem {
  number?: string;
  title: string;
  desc: string;
}

interface CyberFeaturesProps {
  features: FeatureItem[];
  sectionTitle?: string;
  wrapperClass?: string;
  bgBox?: boolean; // toggle feature background box
  columns?: number; // 3 or 2 columns
}

export default function CyberFeatures({
  features,
  sectionTitle,
  wrapperClass = "",
  bgBox = true,
  columns = 3,
}: CyberFeaturesProps) {
  return (
    <div className={`${styles.wrapper} ${wrapperClass} mt-5`}>
      <Container>

        {sectionTitle && (
          <h2 className={`text-center mb-5 ${styles.mainHeading}`}>
            {sectionTitle}
          </h2>
        )}

        <Row className="justify-content-center">
          <Col md={12} lg={10}>
            <div className={bgBox ? styles.featBg : ""}>
              <Row className="g-4 justify-content-center">

                {features.map((item, index) => (
                  <Col
                    key={index}
                    lg={columns === 3 ? 4 : 6}
                    md={6}
                    sm={6}
                    xs={12}
                  >
                    <Card className={styles.card}>
                      {item.number && (
                        <div className={styles.number}>{item.number}</div>
                      )}
                      <h5 className={styles.title}>{item.title}</h5>
                      <p className={styles.desc}>{item.desc}</p>
                    </Card>
                  </Col>
                ))}

              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
